import Vue from 'vue';
import Vuex from 'vuex';
import persistedState from 'vuex-persistedstate';
Vue.use(Vuex);
import { encrypt } from '@/utils/js/2222.js';

const store = new Vuex.Store({
  state: {
    width: 1600,
    height: 557,
    tableH: 600,
    logoName: process.env.VUE_APP_LOGO_NAME,
    accountType: 0, //账户安全中菜单点击id
    mainWidth: 0, //企业端body主体宽度
    bodyWidth: 0, //求职端body主体宽度
    sendText: '发送验证码',
    sendBtnDisable: false,
    sendSmsInterval: 60,
    snedTimer: null,
    user: {
      uid: '',
      username: '',
      real_name: '',
      email: '',
      phone: ''
    },
    timer: null //hash定时器
  },
  mutations: {
    WINDOW_SIZE: (state, wids) => {
      state.height = wids.h;
      state.width = wids.w;
      state.tableH = wids.h - 350;
      state.bodyWidth = state.width / 1.4;
      state.mainWidth = (state.width - 160) / 1.1;
    },
    setUserInfo: (state, info) => {
      if (info.user_id) {
        state.user.uid = info.user_id;
      }
      if (info.username) {
        state.user.username = info.username;
      }
      if (info.email) {
        state.user.email = info.email;
      }
      if (info.phone) {
        state.user.phone = info.phone;
      }
      if (info.real_name) {
        state.user.real_name = info.real_name;
      }
    },
    //设置定时器
    setTimerStauts(state, data) {
      state.timer = data;
    },
    //退出登录，清除存储
    logout(state) {
      localStorage.removeItem('uid');
      localStorage.removeItem('currentMenu');
      localStorage.removeItem('sumForm');
      state.user = {
        uid: '',
        username: '',
        real_name: '',
        email: '',
        phone: ''
      };
    },
    //关闭hash检测定时器
    clearInter(state) {
      clearInterval(state.timer);
    },
    clearSms(state) {
      state.sendBtnDisable = false;
      state.sendText = '发送验证码';
      state.sendSmsInterval = state.sendSmsInterval || 60;
      clearInterval(state.snedTimer);
    },
    //设置验证码状态
    SEND_CODE: (state) => {
      state.snedTimer = setInterval(() => {
        if (state.sendSmsInterval === 0) {
          state.sendBtnDisable = false;
          state.sendText = '发送验证码';
          state.sendSmsInterval = state.sendSmsInterval || 60;
          clearInterval(state.snedTimer);
        } else {
          state.sendBtnDisable = true;
          state.sendSmsInterval--;
          state.sendText = state.sendSmsInterval + 's后重发';
        }
      }, 1000);
    }
  },
  actions: {
    //窗体尺寸
    windowSize({ commit }, wids) {
      commit('WINDOW_SIZE', wids);
    },
    //获取验证码无限制
    sendPhoneCode(context, _params) {
      let _parameter = {
        data: encrypt(JSON.stringify(_params))
      };
      return new Promise((resolve, reject) => {
        window.$vue.$http
          .post('/ajax_phone', _parameter)
          .then((res) => {
            if (res.success === '1') {
              context.commit('SEND_CODE');
              //调用接口成功
            }
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    //获取验证码（验证、限制）
    sendCode(context, _params) {
      if (process.env.NODE_ENV === 'development') {
        let yzm = '';
        for (let i = 0; i < 4; i++) {
          yzm += Math.floor(Math.random() * 10);
        }
        return new Promise((resolve, reject) => {
          context.commit('SEND_CODE');
          console.log(yzm);
          resolve({ yzm: yzm, mobile: _params.mobile, message: '[本地] 验证码发送成功' });
        });
      }
      let _parameter = {
        data: encrypt(JSON.stringify(_params))
      };
      return new Promise((resolve, reject) => {
        window.$vue.$http
          .post('/ajax.php', _parameter)
          .then((res) => {
            context.commit('SEND_CODE');
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  },
  modules: {},
  getters: {},
  plugins: [
    persistedState({
      storage: window.localStorage
    })
  ]
});

export default store;
